export default "__VITE_ASSET__hsRZMCReu_zk_LR9veLc4g__"